"use strict";

// 📕 Libraries, alphabetized
//import * as React from 'react';

// 🧩 Components, alphabetized
//import { Dashboard } from './Dashboard';
//import { Flash } from './Flash';

// 🔧 Utility functions, alphabetized
//import { AuthenticatedRoute } from 'utils/AuthenticatedRoute';
//import { AuthorizedRoute } from 'utils/AuthorizedRoute';

import {
  uuid,
  renderIntoNode,
  createHtmlNodeReferenceFeedback,
  createHtmlNodeFeedback,
} from "./utils/rendering/Utils-Html-Rendering.mjs";

import { getEledaMessage } from "../lang/EledaMessages";

import { Feedback } from "./Feedback.mjs";
import { destroyObjectAttributes } from "./utils/memory/Utils-Memory";

/**
 * Class representing a Question.
 * @property {String} label - label to be displayed
 * @property {Element} solution  - corresponding to goodAnswer
 * @property {Element} answer    - is the answer filled in by user
 * @property {boolean} solutionFound - boolean (set to true when Student has found solution solution==answer)
 * @property {node} htmlNode         - node html representing the question
 * @property {Object} feedbackSolution - solution to display in the feedback
 */
export class Question {
  uuid;
  label;
  solution;
  answer;
  functionSetAnswer;
  solutionFound;
  solutionRendered;
  feedbacks;
  mutationShape;
  disabled;
  error;
  rawOptions;

  //RENDERING
  htmlNode;
  hasDefaultFeedback;
  hasFeedback;
  feedbacksHtmlContainerNode;
  feedbackReferenceIndice; // Integer if mutation =="value"

  feedbackReferenceNode; //node parent of feedbackReferenceNodeIndice if mutation =="value"
  feedbackReferenceNodeIndice; //node of indice
  feedbacksHtmlNode; //node parent of feedbacksHtmlNodeIndice if mutation =="value"
  feedbacksHtmlNodeIndice; //node of indice

  feedbackReferenceNode; // node if mutation =="value" (e.g display of [1] after question)
  style;

  constructor(
    value_label,
    value_solution = null,
    mutationShape = null,
    hasDefaultFeedback,
    hasFeedback
  ) {
    Activity.instances.push(this);
    this.uuid = uuid();
    //appendDEBUG('Question constructor='+this.uuid)
    this.label = value_label;
    this.solution = value_solution;
    this.solutionFound = 0;
    this.feedbacks = [];
    this.hasDefaultFeedback = hasDefaultFeedback;
    this.hasFeedback = hasFeedback;
    this.mutationShape = mutationShape;
    this.style = { color: "black" };
    this.feedbackSolution = this.solution; //solution returned in feedback with modification (cf associate who has "two" solutions )
    this.disabled = false;
    this.error = false;
    this.feedbacksHtmlNode = document.createElement("div");
    this.feedbacksHtmlNode.classList.add("feedback");
  }
  destroy() {
    destroyObjectAttributes(this);
  }

  getMessageSolutionFoundAtFirstAttempt() {
    return getEledaMessage("defaultMessageSolutionFoundAtFirstAttempt");
  }

  getMessageSolutionFound() {
    return getEledaMessage("defaultMessageSolutionFound");
  }

  getMessageSolutionNotFound() {
    console.log("getMessageSolutionNotFound");
    return getEledaMessage("defaultMessageSolutionNotFound");
  }
  getMessageSolutionNotFoundButRemainingAttempts() {
    return getEledaMessage(
      "defaultMessageSolutionNotFoundButRemainingAttempts"
    );
  }

  getUuid() {
    return this.uuid;
  }

  getLabel() {
    return this.label;
  }

  isSolutionRendered() {
    return this.solutionRendered;
  }

  isDisabled() {
    return this.disabled;
  }

  getAnswer() {
    return this.answer;
  }

  getSolution() {
    return this.solution;
  }

  isSolutionFound() {
    return this.solutionFound;
  }

  isGraded() {
    return this.rawOptions.grade;
  }
  getMutationShape() {
    return this.mutationShape;
  }

  /**
   * Return user's feedbacks
   * @returns {Array of Feedback}
   */
  getFeedbacks() {
    return this.feedbacks;
  }

  getRawOptions() {
    return this.rawOptions ?? {};
  }

  /**
   * verify if rawOptions has been filled with an JSON, instanciate an empty one if not
   * @param rawOptions JSON Format options that affect the answer like caseSensitive, in the future it will also allow options on the htmlnode
   */
  validateOptions(rawOptions) {
    this.rawOptions = rawOptions || {};
    //lowercase all keys of rawOptions json
    console.log("validateOptions", this.rawOptions);
    var lowerCaseRawOptions = {};
    for (var key in this.rawOptions) {
      lowerCaseRawOptions[key.toLowerCase()] = this.rawOptions[key];
    }
    this.rawOptions = lowerCaseRawOptions;

    //test if feedbackcolor option is defined (true by default)
    if (this.rawOptions.feedbackcolor !== false) {
      this.rawOptions.feedbackcolor = true;
    } else {
      this.rawOptions.feedbackcolor = false;
    }
    //test if grade is defined (true by default)
    if (this.rawOptions.grade !== false) {
      this.rawOptions.grade = true;
    } else {
      this.rawOptions.grade = false;
    }
  }

  /**
   * Create and add a LocalFeedback from the Blockly block and add push in into feedbacks[]. This method is called by Blockly generated code.
   * @param {function} functionCallbackFeedback Function that return a boolean to trigger the feedback
   */
  addFeedbackLocal(functionCallbackFeedback, defaultFeedback = 0) {
    var feedback = new Feedback(
      this,
      functionCallbackFeedback,
      defaultFeedback
    );
    this.feedbacks.push(feedback);
    return feedback;
  }

  setStyle(jsonStyle) {
    this.style = { ...this.style, ...jsonStyle };
  }

  setFeedbackIndice(int) {
    this.feedbackReferenceIndice = int;
  }

  /**
   * Implemented by Children
   */
  setAnswer() {}

  /***********************************
   * RENDERING FUNCTIONS
   ************************************ */

  render(node) {
    console.log("Render Question this.mutationShape", this.mutationShape);
    if (this.mutationShape == "statement") {
      this.htmlNode = document.createElement("fieldset");
      this.htmlNode.classList.add("statement");
    } else {
      this.htmlNode = document.createElement("span");
      this.htmlNode.classList.add("value");
    }
    this.htmlNode.setAttribute("id", this.uuid);
    this.htmlNode.classList.add("question");
    node.appendChild(this.htmlNode);
    this.initFeedbacksHtmlContainerNode();
  }

  renderLabel(labelNode) {
    renderIntoNode(this.label, labelNode);
  }

  /**
   * Add the node Feedbacks container that will receive div feedback
   */
  initFeedbacksHtmlContainerNode(currentAttempt, maxAttempts) {
    if (this.mutationShape == "value") {
      this.feedbacksHtmlContainerNode = document.createElement("div");
      this.feedbacksHtmlContainerNode.setAttribute(
        "id",
        this.uuid + "-feedback"
      );
      this.htmlNode.appendChild(this.feedbacksHtmlContainerNode);
      document
        .getElementById("value-questions-feedbacks")
        .appendChild(this.feedbacksHtmlContainerNode);
    }
  }

  renderFeedbacks(currentAttempt, maxAttempts) {
    this.initFeedbacksHtmlNode(currentAttempt, maxAttempts);
    //Ask all feedbacks to render
    this.feedbacks.forEach((feedback) =>
      feedback.render(this.feedbacksHtmlNode)
    );

    if (this.mutationShape == "value" && this.rawOptions.feedbackcolor) {
      this.renderHighlightIndice(currentAttempt, maxAttempts);
    }
  }

  getHighligthClass(currentAttempt, maxAttempts) {
    let classToAdd = "";
    if (this.solutionFound) {
      classToAdd = "is-success";
    } else if (!this.solutionFound && currentAttempt < maxAttempts - 1) {
      classToAdd = "is-orange";
    } else {
      classToAdd = "is-danger";
    }
    return classToAdd;
  }

  //Depending on solutionFound highlight success or fail question's fieldset
  renderHighligthFieldSet(currentAttempt, maxAttempts) {
    if (this.rawOptions.feedbackcolor) {
      this.htmlNode.classList.add(
        this.getHighligthClass(currentAttempt, maxAttempts)
      );
    }
  }

  renderHighlightIndice(currentAttempt, maxAttempts) {
    this.feedbackReferenceNodeIndice.classList.add(
      this.getHighligthClass(currentAttempt, maxAttempts)
    );
    this.feedbacksHtmlNodeIndice.classList.add(
      this.getHighligthClass(currentAttempt, maxAttempts)
    );
  }

  /**
   * Initialize the Feedback Html Node within this Question which will host feedbacks
   */
  initFeedbacksHtmlNode(currentAttempt, maxAttempts) {
    //Init HTML Container which will receive feedback

    this.feedbacksHtmlNode.innerHTML = "";

    // this.feedbacksHtmlNode.replaceChildren();
    // if statement question just, put in this.htmlNode
    if (this.mutationShape == "statement") {
      this.htmlNode.appendChild(this.feedbacksHtmlNode);
    } else {
      //If value question : put the reference node just after (not inside htmlNode) to avoid weird behavior in input field
      this.feedbackReferenceNode = document.createElement("span");
      this.feedbackReferenceNodeIndice = createHtmlNodeReferenceFeedback(
        this.feedbackReferenceIndice
      );
      this.feedbackReferenceNode.appendChild(this.feedbackReferenceNodeIndice);

      //then put the same reference into value feedback
      this.feedbacksHtmlNodeIndice = createHtmlNodeReferenceFeedback(
        this.feedbackReferenceIndice
      );
      this.feedbacksHtmlNode.appendChild(this.feedbacksHtmlNodeIndice);

      this.htmlNode.parentNode.insertBefore(
        this.feedbackReferenceNode,
        this.htmlNode.nextSibling
      );
      this.feedbacksHtmlContainerNode.appendChild(this.feedbacksHtmlNode);
    }
  }

  renderSolution() {
    this.solutionRendered = true;
  }

  /**
   * Disable question, to make it not editable after the last attempt or if solutionFound
    this.questionsToCheck = [
   */
  disable() {
    this.disabled = true;
  }

  cleanFeedbacks() {
    console.log("Feedback Question");
    if (this.feedbacksHtmlNode) {
      this.feedbacksHtmlNode.remove();
      if (this.feedbackReferenceNode) {
        this.feedbackReferenceNode.remove();
      }
    }
    this.htmlNode.classList.remove("is-success", "is-danger", "is-orange");
  }

  addDisplayFeedback(text, type) {
    let statementFeedbacksNode = createHtmlNodeFeedback(text, type);
    renderIntoNode(statementFeedbacksNode, this.feedbacksHtmlNode);
    //this.feedbacksHtmlNode.append(statementFeedbacksNode);
  }
}
